<section class="who-do-we-work-for-day">
  <h1 class="who-do-we-work-for-day__title">{{ 'whoDoWeWorkForDay.title' | transloco }}</h1>
  <h2 class="who-do-we-work-for-day__relation">{{ 'whoDoWeWorkForDay.relation' | transloco }}</h2>
  <div class="who-do-we-work-for-day__delivery">
    <p class="who-do-we-work-for-day__delivery__content right">{{ 'whoDoWeWorkForDay.deliveryRight' | transloco }}</p>
    <p class="who-do-we-work-for-day__delivery__content center">{{ 'whoDoWeWorkForDay.deliveryCenter' | transloco }}</p>
    <p class="who-do-we-work-for-day__delivery__content left">{{ 'whoDoWeWorkForDay.deliveryLeft' | transloco }}</p>
  </div>
  <img class="who-do-we-work-for-day__sun__icon" src="assets/img/amvara_web_icon_sun.svg" [routerLink]="language.link(['who-do-we-work-for'])" [attr.alt]="'common.goBack' | transloco" />
  <img [attr.alt]="'common.goBack' | transloco" class="who-do-we-work-for-day__back" [routerLink]="language.link(['about'])" src="assets/img/amvara_web_icon_(less).svg">
</section>
